<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm">
  <div class="xrx-slider d-flex align-items-center" style="position: relative">
    <xrx-input-group
      type="text"
      id="slider-value"
      name="slider-value"
      [(ngModel)]="value"
      [maxlength]="4"
      [autofocus]="false"
      appendText="%"
      (change)="onSliderInputChange()"
      (keydown)="onSliderInputKeyDown($event)"
      [error]="sliderInputError"></xrx-input-group>
    <div
      class="slider-wrapper align-items-end d-flex flex-grow-1"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)">
      <div
        #xrxSlider
        class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all flex-grow-1">
        <span class="ui-slider-value first">{{ min }}</span>
        <span class="ui-slider-value last">{{ max }}</span>
        <a
          #slideThumb
          class="ui-slider-handle ui-state-default ui-corner-all"
          href="#"
          tabindex="0"
          (keydown)="onKeyDown($event)"
          [style.left.px]="position">
          <div class="slider-bars-container clearfix">
            <div class="bar">&nbsp;</div>
            <div class="bar">&nbsp;</div>
            <div class="bar">&nbsp;</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</form>
